import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { t } from "../../../../../../core/i18n/i18n";
import { IconButton } from "@material-ui/core";
import { Warning } from "@material-ui/icons";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    column: {
      flex: "1 1 50%",
      display: "flex",
      alignItems: "center",
      paddingLeft: "20px"
    },
    icon: {
      color: theme.palette.error.dark
    }
  })
);

export const TreeMetaDisplay = (props: {
  infos: string[];
  warnings: string[];
}) => {
  const classes = useStyles();
  const { infos, warnings } = props;

  const view = () => {
    if (infos?.length || warnings?.length) {
      return (
        <div className={classes.column}>
          <IconButton
            classes={{ root: classes.icon }}
            size={"small"}
            color="secondary"
          >
            <Warning />
          </IconButton>
          {infos.length > 0 &&
            infos.map((info: string, index: number) => (
              <Typography key={index} color="inherit">
                {t("hns:tree:treeBlock:meta:info:" + info)()}
              </Typography>
            ))}
          {warnings.length > 0 &&
            warnings.map((warning: string, index: number) => (
              <Typography key={index} color="inherit">
                {t("hns:tree:treeBlock:meta:warning:" + warning)()}
              </Typography>
            ))}
        </div>
      );
    } else {
      return <></>;
    }
  };
  return view();
};
